import React from 'react';
import * as ReactDOM from 'react-dom';
import { PropTypes } from 'prop-types';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { ConfirmDialogContext } from '@seccon/core/contexts/confirm';
import { FooterContext } from '@seccon/core/contexts/footer';
import useEndSession from '../hooks/useEndSession';
import { useOverviewDataContext } from '../context/OverviewDataContext';

const styles = {
  actionButton: {
    minWidth: '100px'
  },
  container: {
    display: 'flex',
    flexWrap: 'nowrap',
    borderTop: 1,
    borderColor: 'grey.400',
    boxSizing: 'border-box',
    p: 3,
    width: '100%',
    justifyContent: 'space-between'
  },
  leftContainer: {
    display: 'flex',
    flexWrap: 'nowrap'
  },
  rightContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row-reverse',
    gap: 1
  }
};

const FormFooter = ({
  children
}) => {
  const footerEl = React.useContext(FooterContext);
  const { isError, facilityId } = useOverviewDataContext();
  const confirm = React.useContext(ConfirmDialogContext);
  const { mutateAsync: handleEndSession } = useEndSession();

  const onEndSession = () => {
    confirm(
      'Create Records',
      'Ending the session will delete the current session and clear the peresonnel report that was uploaded earlier. Are you sure you want to proceed?',
      () => handleEndSession()
    );
  };

  const onBack = () => {
    window.location.href = `/personnel/list?facilityId=${ facilityId }`;
  };

  if (footerEl === null) {
    return null;
  }

  const content = (
    <Box sx={styles.container}>
      <Box sx={styles.leftContainer}>
        {!isError && (
          <Button onClick={onEndSession} color='error' variant='outlined' sx={styles.actionButton}>
            End Session
          </Button>
        )}
      </Box>
      <Box sx={styles.rightContainer}>
        {children}
        <Button onClick={onBack} variant='outlined' sx={styles.actionButton}>
          Back
        </Button>
      </Box>
    </Box>
  );
  return ReactDOM.createPortal(content, footerEl);
};

FormFooter.propTypes = {
  children: PropTypes.node
};

FormFooter.defaultProps = {
  children: null
}
export default FormFooter;
